module.exports = __webpack_public_path__ + "img/burgos.45a30db3.jpg";